import { styled } from '@nykaa/ui-components';
import {
  LISTING_TITLE_ZINDEX,
  SORT_CONTAINER_WIDTH,
} from 'shared/layouts/Listing/Desktop/components/Layout/constants';
import { TITLE_SORT_GAP } from 'shared/layouts/Listing/Desktop/components/Layout/components/AppliedFiltersAndSort/constants';

export const Heading = styled.h1`
  ${({ theme }) => theme.typography.titleMedium};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  align-items: baseline;
`;

export const Wrapper = styled.div<{
  isSticky: boolean;
  containerTop: number;
  isStickyContainer: boolean;
  isFiltersApplied: boolean;
}>`
  ${({ isStickyContainer }) => isStickyContainer && `position: sticky`};
  ${({ isStickyContainer, containerTop }) => isStickyContainer && `top:  ${containerTop}px`};
  z-index: ${LISTING_TITLE_ZINDEX};

  width: ${({ isSticky, isFiltersApplied, isStickyContainer }) => {
    if (!isStickyContainer || !isSticky) return '100%';
    if (isFiltersApplied) return '20%';
    return `calc(100% - ${SORT_CONTAINER_WIDTH + TITLE_SORT_GAP}px)`; // in case filters are not applied
  }};

  ${({ isStickyContainer, isSticky, theme }) =>
    isStickyContainer
      ? !isSticky && `margin-bottom:${theme.spacing.spacing160}`
      : `margin-bottom:${theme.spacing.spacing100}`};
  display: flex;
  background-color: ${({ theme }) => theme.colors.surface};
  padding-top: ${({ theme }) => theme.spacing.spacing100};
  ${({ isSticky, theme }) => isSticky && `margin-bottom:${theme.spacing.spacing100}`};
  box-sizing: border-box;
  align-items: baseline;
`;
export const Label = styled.label`
  ${({ theme }) => theme.typography.titleMedium};
  color: ${({ theme }) => theme.colors.textPrimary};
`;
